import React, { Component } from "react";
import PageHelmet from "./Helmet";
import Breadcrumb from "./Breadcrumb";
import CounterOne from "./CounterOne";
import Testimonial from "./Testimonial";
import BrandTwo from "./BrandTwo";
import { FaFacebookF , FaLinkedinIn , FaTwitter } from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../../../Layout/Main/header/Header";
import Footer from "../../../Layout/Main/footer/FooterTwo";
import { NavLink } from 'react-router-dom';
const Content = [
{
    subTitle: 'Make a checklist of your items',
    Content: 'First, make a checklist of what household items you required. Everyone"s list is different because it all depends on how much time do you have. Some people have two months for packing while some have only two weeks. So, arrange your checklist accordingly.',
    id: 1
},
{
    subTitle: 'Categorize so you can pick less',
    Content: 'A crucial packing tip is to make a list of things you do not need. You can lighten your stress and workload by sell or donate all the stuff you no longer need. Measure the new place where you are going and get rid of all furniture that will not fit in your new location.',
    id: 2
},
{
    subTitle: 'Purchase some quality moving boxes',
    Content: 'If you want to put heavy things in boxes, then buy boxes of good quality, so they do not fall apart in your hands while you are trying to move it into other places. Grocery boxes or reused boxes can be compromised due to moisture.',
    id: 3
},
{
    subTitle: 'First pack essential things',
    Content: 'When you are moving to a new place first pack the things which you needed most, because all the boxes contain the same color, so you do not mix the essential stuff.',
    id: 4
},
{
    subTitle: 'Use the color packing label.',
    Content: 'To stay organized, use the color label and put it on boxes. This moving tip can save your ton of time. You do not have to get panic for finding the important material. ',
    id: 5
},
{
    subTitle: 'Do not overload your moving box',
    Content: 'A lot of people made a massive mistake while moving; they cram all their belongings in a few boxes and overload them. As a result, the box itself unbox in your hand. Use as many boxes as you need to create easy-to-lift loads. Try to keep your most jumbo boxes to not more than fifty pounds.',
    id: 6
},
{
    subTitle: 'Use the right box for the right material',
    Content: 'Put heavy material like books in small boxes and light things in large boxes to make it easier for the mover to organize and pack all boxes in the moving truck. Make sure to put heavier items on the bottom and the lighter one on the top to avoid damaging the fragile items.',
    id: 7
},
{
    subTitle: 'Fill all the spaces in the box',
    Content: 'After putting all the material in the box, if the small spaces left then, fill that spaces with packing paper, clothing or form, peanuts, etc. Use tape at the bottom and top of the box. You can also use tape in places where stress is concentrated.',
    id: 8
},


];
class Tips extends Component{
    render(){
        let title = 'Moving Checklist ';
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Moving Checklist - Tips for Move Planning' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                {/* Start Breadcrump Area */}
                <Breadcrumb title={'Moving Checklist'}   />
                {/* End Breadcrump Area */}

                {/* Start About Area  */}
                <div className="rn-about-area ptb--120 bg_color--1">
                    <div className="rn-about-wrapper">
                        <div className="container">
                            <div className="row row--35 align-items-center">
                                {/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
                                <div className="col-lg-9 text-center">
                                    <div className="about-inner inner">
                                        <div className="section-title">
                                            <h2 className="title text-left">{title}</h2>
                                            <p className="description text-left pt--50">While moving to a new place can be fun, we all know that the moving process itself can cause a lot of stress. If you are planning to move out soon, here are a couple of moving tips you need to know about and a checklist you should follow. First of all, you need to decide if you will be moving by yourself or hiring movers since, in most cases, hiring movers takes half of that stress away. So consider visiting or talk to your local moving company like moonline moving. Here’s the perfect checklist for your moving day.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Two months before the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>You should start getting organized, which means that you should set aside a folder or file where you will put all your work-related papers and anything related to your job. After that, you should start to sort your items, which means that you should throw out or donate anything that you will no longer need.
When you are done with that, you might want to research the moving companies in your area. There are plenty of moving companies out there, and you should find the one that suits your taste the best. Make sure you hire movers with a great reputation.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">1.5 months before the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Start by getting supplies and buying packing materials, such as tape, markers, boxes, bubble wrap, and anything else you might need. You should also have a garage sale if there are plenty of items you no longer need.
You can also notify schools if you have children, and let them know that you will soon be moving. If your kids are changing schools, you need to get their papers and look for new schools where they could be enrolled in. The same applies to all your medical papers. After you have all of that done, you might want to consider actually booking the movers. Call and set up the perfect date that works for both of you. 
</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">One month before the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>You can start the packing process one month before the move. If you don't have time for packing, don’t fret Vancouver moving company like Moonline moving offer the services of packing, unpacking, and crating. You can start your packing process by packing the items you do not often use. For example, start with small things, such as toys, decorations, and so on. Notify utilities to start the process of closing the utility service at your current place, and you should also notify your landlord. Make sure that all of your boxes are neatly labeled.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Packaging material and furniture plan </h3>
                                            <ul className="text-left pt--30 pl--20" style={{fontSize:'20px'}}>
                                                <li>Make the small repairs that are your responsibility as a tenant. Report any damage to management or hire a craftsman yourself. Report everything to your household or liability insurance.</li>
                                                <li>Bring the furniture now in need of repair. You will not have to move them. Have the repaired items delivered to your new address.</li>
                                                <li>You can donate or sell furniture and appliances that you no longer need or don't want to move. Dispose of damaged things properly.</li>
                                                <li>Return all borrowed books, games or DVDs.</li>
                                                <li>Empty your freezer gradually so that you don't have to worry about frozen products on the day of the move. Check that there is an electrical connection suitable for the freezer at your new address.</li>
                                                <li>Reserve necessary devices such as a pressure washer or carpet cleaner in a good time. You can, for example, rent them from drugstores, DIY stores, and moving companies.</li>
                                                <li>Provide enough packing material. Perhaps you know someone who has just moved and who could "give" boxes and equipment to you. Moving companies and department stores also offer packaging materials for sale or rental.</li>
                                                <li>For instance, if you are in Canada hire the Victoria moving company, ask them to provide identification materials, such as self-adhesive or hanging labels. The ideal is to identify the boxes and furniture from the start according to their destination in the new apartment (according to the furniture plan). For example, you can adopt a color code: red for the kitchen, blue for the bathroom, green for the living room.</li>
                                            </ul>    
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">3 weeks before the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Make arrangements for your children and pets to have daycare during the actual moving process, and make sure to change your address, transfer your insurance and strategize the food situation, so you do not end up throwing too much</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">1-2 weeks before the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Confirm with your movers the date and time that they are scheduled to come and pack your essential kit. When packing the essentials, make sure that that box is always near you, just like medicine, important documents, and everything similar.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Set the date of the move</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Ask your new landlord exactly when you can move in and agree on the exact date and time. If the date indicated in the contract falls on a Saturday, a Sunday or a public holiday, the first move-in date is postponed to the first following working day. Communicate the date of the move to your employer and request a paid day off for the move. </p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Book the moving company </h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>Book the moving vehicle or moving company in time and, if possible, from the evening before D-Day. Check that you have all the keys to the old apartment. If you no longer know how many there should be, check the number mentioned in the old rental contract or in the key list.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Moving day:</h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>On Moving day, try to wake up early in the morning. Gather your supplies and keep your checklist on hand to ensure that you are handling each item as planned. Take the final sweep of your home before you move out. Hand over the keys to the new owners or landlord.</p>
                                        </div>
                                        <div className="section-title pt--100">
                                            <h3 className="text-left">Bottom line:  </h3>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'40px'}}>By following this simple checklist, you will not have any issues during the actual moving day. When your movers arrive, ask them if they need help and tell them which boxes are fragile and all those details. Make sure you are not a hassle to them since most movers prefer to load the boxes themselves, as they already know how things should go. </p>
                                            <p style={{textAlign: '-webkit-auto',paddingTop:'10px'}}>Whether you are looking to hire the moving company to help move your home, MoonLine Moving is here to make sure your moving is as stress-free as possible. Give us a call today at <b>+1 604 595 2800</b> and book your move or moving <NavLink to="/"><b>free quote</b></NavLink>. Happy moving! </p>
                                        </div>
                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            
                {/* End About Area  */}

                 {/* Start CounterUp Area */}
                 {/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
                {/* End CounterUp Area */}

                {/* Start Finding Us Area  */}
                <div className="rn-finding-us-area rn-finding-us bg_color--1">
                    {/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
                </div>
                {/* End Finding Us Area  */}

                {/* Start Team Area  */}
                <div className="rn-team-area bg_color--1 ptb--120">
                    <div className="container">
                        {/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
                        <div className="row">
                            
                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                            {/* Start Single Team  */}
                            {/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
                            {/* End Single Team  */}

                        </div>
                    </div>
                </div>
                {/* End Team Area  */}

                {/* Start Testimonial Area */}
                {/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
                {/* End Testimonial Area */}

                {/* Start Brand Area */}
                {/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* End Brand Area */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />

            </React.Fragment>
        )
    }
}
export default Tips;